/* eslint-disable sort-keys */
export const urls: Record<
  'nl-en',
  Record<string, '/l/nl/en' | `/l/nl/en/${string}`>
> = {
  'nl-en': {
    // Home
    '': '/l/nl/en/home',

    // Alumni
    alumni: '/l/nl/en/alumni',

    // B2B
    enterprise: '/l/nl/en/b2b',
    'enterprise/contact': '/l/nl/en/b2b/apply',

    // Campus
    amsterdam: '/l/nl/en/campus/ams',
    remote: '/l/nl/en/campus/rmt',

    // Career
    career: '/l/nl/en/career',

    // Courses
    'web-development': '/l/nl/en/course/wd',
    'data-analytics': '/l/nl/en/course/da',
    'ux-ui-design': '/l/nl/en/course/ux',
    cybersecurity: '/l/nl/en/course/cy',

    // FAQ
    faq: '/l/nl/en/faq',

    // Financing Options
    'financing-options': '/l/nl/en/financing',

    // Forms
    apply: '/l/nl/en/apply',
    apply2: '/l/nl/en/full-apply',
    contact: '/l/nl/en/contact',
    'financing-form': '/l/nl/en/financing-form',
    'thank-you': '/l/nl/en/thank-you',

    // Syllabus Forms
    'ai-consulting-integration/syllabus': '/l/nl/en/syllabus/ac',
    'artificial-intelligence/syllabus': '/l/nl/en/syllabus/ai',
    'cloud-engineer/syllabus': '/l/nl/en/syllabus/ce',
    'cybersecurity/syllabus': '/l/nl/en/syllabus/cy',
    'data-analytics/syllabus': '/l/nl/en/syllabus/da',
    'data-engineering/syllabus': '/l/nl/en/syllabus/de',
    'devops-cloud-computing/syllabus': '/l/nl/en/syllabus/dv',
    'digital-marketing/syllabus': '/l/nl/en/syllabus/mk',
    'data-science-machine-learning/syllabus': '/l/nl/en/syllabus/ml',
    'ai-product-manager/syllabus': '/l/nl/en/syllabus/pm',
    'ux-ui-design/syllabus': '/l/nl/en/syllabus/ux',
    'web-development/syllabus': '/l/nl/en/syllabus/wd',

    // PDP
    'ai-consulting-integration/remote': '/l/nl/en/pdp/ac/rmt',
    'artificial-intelligence/remote': '/l/nl/en/pdp/ai/rmt',
    'cloud-engineer/remote': '/l/nl/en/pdp/ce/rmt',
    'cybersecurity/amsterdam': '/l/nl/en/pdp/cy/ams',
    'cybersecurity/remote': '/l/nl/en/pdp/cy/rmt',
    'data-analytics/amsterdam': '/l/nl/en/pdp/da/ams',
    'data-analytics/remote': '/l/nl/en/pdp/da/rmt',
    'data-engineering/remote': '/l/nl/en/pdp/de/rmt',
    'devops-cloud-computing/remote': '/l/nl/en/pdp/dv/rmt',
    'digital-marketing/remote': '/l/nl/en/pdp/mk/rmt',
    'data-science-machine-learning/remote': '/l/nl/en/pdp/ml/rmt',
    'ai-product-manager/remote': '/l/nl/en/pdp/pm/rmt',
    'ux-ui-design/amsterdam': '/l/nl/en/pdp/ux/ams',
    'ux-ui-design/remote': '/l/nl/en/pdp/ux/rmt',
  },
};
/* eslint-enable sort-keys */
